import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import AdminInvitePanel from '../../../components/admin/user-invites/AdminInvitePanel';

const Invites = () => {
    const { t } = useTranslation();

    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>{t('Invites')}</title>
                    <meta property="og:title" content={t('Invites')} />
                </Helmet>
            </HelmetProvider>

            <div className="container">
                <h3 className="fw-light text-muted text-center mb-3">
                    {t('Invites')}
                </h3>

                <p className="text-muted text-center mb-4">
                    {t('Generate time-limited invite links for Google Sign-In.')}
                </p>

                <AdminInvitePanel />
            </div>
        </>
    );
};

export default Invites;
